import ValidateGlobal from './../ValidateGlobal.js'
import ServiceGlobal from './../InputsServiceGlobal.js'
import NumberUtilsLibs from '@/plugins/Utils/NumberUtils'
import NafNumeric from './NafNumeric.vue'
import numeral from 'numeral'

const DEFAULT_FORMAT = '0,0.[00000]'
export default {
  mixins: [ValidateGlobal, ServiceGlobal],
  components: {
    NafNumeric
  },
  props: {
    config: {
      type: Object
    },
    modelProps: {
      type: [Number, String]
    },
    rootModel: {
      type: Object
    },
    parent: {
      type: Object
    },
    originModel: {
      type: [Number, String]
    }
  },
  model: {
    prop: 'modelProps',
    event: 'input'
  },
  data () {
    return {
      value: this.modelProps,
      oldValue: this.modelProps,
      NumberUtils: NumberUtilsLibs
    }
  },
  created () {
    this.initValue()
    this.$on('onInput', this.onInput)
  },
  watch: {
    value(newValue, oldValue) {
      this.oldValue = oldValue
    },
    modelProps: {
      handler: function() {
        // console.log('modelprops changed')
        if(this.config.watch) {
          this.onInput(this.modelProps)
        }
      },
      deep: true
    }
  },
  computed: {
    validationRules () {
      if(typeof this.config.validation === 'string') {
        return this.expressionResolver(`${this.config.validation}|decimal`)
      }
      if(typeof this.config.validation === 'object') {
        return this._.merge(this.config.validation, { decimal: true })
      }
      return this.expressionResolver(this.config.validation)
    }
  },
  methods: {
    initValue() {
      if(this.modelProps) {
        this.value = this.config.format ? numeral(this.modelProps).format(typeof this.config.format === 'string' ? this.config.format : DEFAULT_FORMAT) : numeral(this.modelProps)._value
      }
    },
    onInput(newData) {
      let parsed = !this._.isNil(newData) ? numeral(newData)._value : null
      this.value = parsed
      this.$emit('input', parsed)
      this.onChange()
    },
    onBlur () {
      this.$emit('input', !this._.isNil(this.value) ? numeral(this.value)._value : null)
      this.value = !this._.isNil(this.value) ? 
        (this.config.format ? numeral(this.modelProps).format(typeof this.config.format === 'string' ? this.config.format : DEFAULT_FORMAT) : 
        numeral(this.modelProps)._value) : null
      if(this.config.onBlur) {
        eval(this.config.onBlur)
      }
    },
    onFocus() {
      this.value = numeral(this.value)._value
    },
    onChange() {
      if(this.config.onChange) {
        eval(this.config.onChange)
      }
    }
  }
}
